import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./pages/flights/HomePage";
import SearchResults from "./pages/flights/SearchResults";
import BookingDetails from "./pages/flights/BookingDetails";
import BookingSummary from "./pages/flights/BookingSummary";
import SearchBooking from "./pages/flights/SearchBooking";
import Footer from "./components/flights/Footer";
import { config } from "./config";
import AboutUs from "./pages/flights/AboutUs";
import PrivacyPolicy from "./pages/flights/PrivacyPolicy";
import TermsConditions from "./pages/flights/TermsConditions";
import BookingConfirmation from "./pages/flights/BookingConfirmation";
import HotelsHomePage from "./pages/hotels/HomePage";
import HotelsSearchResults from "./pages/hotels/SearchResults";
import HotelsBookingSummary from "./pages/hotels/BookingSummary";
import HotelsBookingConfirmation from "./pages/hotels/BookingConfirmation";
import HotelsPaymentScreen from "./pages/hotels/PaymentScreen";
import HotelsSearchBooking from "./pages/hotels/SearchBooking";
import HotelInformation from "./pages/hotels/HotelInformation";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function App() {
  useEffect(() => {
    document.title = config.flightSiteName;
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = config.logoSrc;
    }
    const appleIcon = document.querySelector('link[rel="apple-touch-icon"]');
    if (appleIcon) {
      appleIcon.href = config.logoSrc;
    }
  }, []);

  return (
    <Router>
      <Elements stripe={stripePromise}>
      <div className="flex flex-col min-h-screen">
        <div className="flex-grow">
          <Routes>
          
            {/* Navigate */}  
            <Route path="/" element={<Navigate to="/flights" replace />} />

            {/* Flight Routes */}
            <Route path="/flights" element={<HomePage />} />
            <Route path="/flights/search" element={<SearchResults />} />
            <Route path="/flights/details" element={<BookingDetails />} />
            <Route path="/flights/summary" element={<BookingSummary />} />
            <Route path="/flights/confirmation" element={<BookingConfirmation />}/>
            <Route path="/flights/booking/search" element={<SearchBooking />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />

            {/* Hotel Routes */}
            <Route path="/hotels" element={<HotelsHomePage />} />
            <Route path="/hotels/search" element={<HotelsSearchResults />} />
            <Route path="/hotels/hotelInformation" element={<HotelInformation />} />
            <Route path="/hotels/summary" element={<HotelsBookingSummary />} />
            <Route path="/hotels/payment" element={<HotelsPaymentScreen />} />
            <Route path="/hotels/confirmation" element={<HotelsBookingConfirmation />} />
            <Route path="/hotels/booking/search" element={<HotelsSearchBooking />} />

          </Routes>
        </div>
        <Footer />
      </div>
      </Elements>
    </Router>
  );
}

export default App;
